import * as React from 'react'
import { connect } from 'react-redux'
import { routerActions, RouterAction } from 'react-router-redux'
import '../styles/App.scss'
import Lightbox from 'react-images-zoom'
import { FlatButton } from 'material-ui'

import { JobCategories } from '../types/jobCategories'
import { AttachmentParams } from '../types/AttachmentParams'

import JobCategory from '../components/JobCategory'
import PickupLocationInfo from '../components/PickupLocationInfo'
import { Uploader } from '../components/AddPictures'
import PickupTime from '../components/PickupTime'
import Comment from '../components/Comment'
import NumberOfItems from '../components/NumberOfItems'
import JobItemDetails from '../components/JobItemDetails'
import PageTitle from '../components/PageTitle'
import ErrorDialog from '../components/ErrorDialog'
import { StickyContainer, Sticky } from 'react-sticky'
import * as ReaderUtils from '../utils/ReaderUtils'
import * as exif from 'exif-js'
import { ImageUtils } from '../utils/ImageUtils'

import { AppBarContainer } from './CustomAppBar'
import {
    selectJobCategory,
    addComment,
    setBagsNumber,
    setItemsOutside,
    setItemsInside,
    setFutureDateFrom,
    setFutureDateTo,
    setAmount,
    setMsaId,
    setElevatorUse,
    setStairsNeeded,
    setAttachments,
    setJobCategories,
    setSelectedJobCategory,
    setSubCategories,
    setTime,
    setTimeMarks,
    setAddress,
    setCoords,
    setApartmentNumber,
    setZipCode,
    removeAllImages,
    resetCheckboxes,
    saveTextareaHeight,
    setJobRequestId
} from '../actions/setJobDetails'

import {
    Actions as ServiceInfoActions,
    ActionType as ServiceInfoActionType
} from '../actions/serviceInfo'

import { Api } from '../services/api/api'

import * as moment from 'moment'

import { ROUTES } from '../constants/routes'
import { IMAGES_MAX_NUMBER } from '../constants/jobDetails-constants'
import * as jobCategoryNames from '../constants/jobCategoryNames'
import { Actions } from '../constants/components/AcceptDialog'
import { IMAGE_CONSTANTS } from '../constants/image'
import { AcceptDialog } from '../components/AcceptDialog'
import { JobPrototype, LatLng, AddressInfo, Enums } from '../types'

import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { LoadingSpinner } from '../components/LoadingSpinner'
import { Strings } from '../localization'
import { StringResources } from '../localization/StringResources'

import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'
import ReactDOM from 'react-dom'

import {
    ActionType as ErrorInfoActionType,
    Actions as ErrorActions
} from '../actions/errorInfo'
import { Error as ErrorInfo } from '../types/Errors/Error'
import Mapper from '../utils/Mapper'
import { PreferenceType } from '../types/enums'
import MessageDialog, { MessageDialogProps } from '../components/MessageDialog'
import { JobRequestStatus } from '../types/JobRequest'

interface JobDetailsState {
    files: Array<any>
    note: string
    jobCategoryName: string
    showImageEditor?: boolean
    fieldsError?: boolean
    userAvatarBg: any
    jobCategories: JobCategories[]
    isImagesUploaded: boolean
    subCategories: Array<any>
    isValid?: boolean
    isImagesMaxNumber: boolean
    isDialogOpen: boolean
    imageId?: string
    isLoading: boolean
    errorTitle: string
    errorMessage: string
    isErrorDialogOpen: boolean
    isLoadingImg: boolean
    isImagesBoxOpen: boolean
    isInappropriatePhoto: boolean
    photoIndex: number
    currentOperation: string
    twoJobPicturesMessage: string
    messageDialog: MessageDialogProps
    jobRequestId?: string
}

interface JobDetailsProps {
    jobPrototype: JobPrototype
    setUseCurrentJob: () => ServiceInfoActionType
    onSelectJobCategory: (name: string, id: string) => void
    onAddComment: (event: string) => string
    onSetFutureDateFrom: (futureDateFrom: number) => void
    onSetFutureDateTo: (futureDateTo: number) => void
    onNumberOfBags: (event: any) => any
    onSetItemsOutside: (areItemsOutside: boolean) => void
    onSetItemsInside: (areItemsInside: boolean) => void
    onSetAmount: (amount: number) => void
    onSetMsaId: (msaId: string) => void
    onSetElevatorUse: (isElevatorNeeded: boolean) => void
    onSetStairsNeeded: (needed: boolean) => void
    onSetAttachments: (files: Array<any>) => void
    onSetJobCategories: (jobCategories: Array<any>) => void
    onSetSelectedJobCategory: (selectJobCategory: string) => void
    onSetSubCategories: (subCategories: Array<any>) => void
    onSetTime: (time: {
        time: number
        futureTime: number
        isFuture: number
        minTime: number
    }) => void
    routePush: (location: string) => RouterAction
    onSetTimeMarks: (marks: any) => void
    jobDetails: any
    zipCode: string
    setAddress: (address?: AddressInfo) => any
    setCoords: (coords?: string) => any
    setApartmentNumber: (apartmentNumber?: string) => any
    setZipCode: (zipCode?: string) => any
    onRemoveAllImages: () => void
    onResetCheckboxes: () => void
    saveTextareaHeight: (minHeight: number) => void
    onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
    setJobRequestId: (jobRequestId?: string) => any
}

class SetJobDetailsComponent extends React.Component<
    JobDetailsProps,
    JobDetailsState
> {
    scroll: any = React.createRef()
    constructor(props: JobDetailsProps) {
        super(props)
        this.state = {
            isLoading: false,
            files: this.props.jobDetails.attachments,
            note: this.props.jobDetails.note,
            jobCategoryName: this.props.jobDetails.jobCategoryName,
            showImageEditor: false,
            fieldsError: true,
            userAvatarBg: {},
            jobCategories: this.props.jobDetails.jobCategories,
            isImagesUploaded: true,
            subCategories: this.props.jobDetails.subCategories,
            isImagesMaxNumber: false,
            isDialogOpen: false,
            errorTitle: '',
            errorMessage: '',
            isErrorDialogOpen: false,
            isLoadingImg: false,
            isImagesBoxOpen: false,
            photoIndex: 0,
            currentOperation: '',
            isInappropriatePhoto: false,
            twoJobPicturesMessage: '',
            messageDialog: {
                isDialogOpened: false
            },
            jobRequestId: this.props.jobDetails.jobRequestId
        }
        if (this.props.jobPrototype) {
            this.props.setAddress(this.props.jobPrototype.address)
            this.props.setCoords(this.props.jobPrototype.coordinates)
            this.props.setApartmentNumber(
                this.props.jobPrototype.address
                    ? this.props.jobPrototype.address.apartmentNumber
                    : ''
            )
            this.props.setZipCode(this.props.jobPrototype.zipCode)
        }
    }

    async componentDidMount() {
        this.checkValidation(this.props)
        if (this.props.jobPrototype) {
            this.setState(
                {
                    isLoading: true
                },
                () => {
                    Api.getCategoriesByZipCode(
                        this.props.jobPrototype
                            ? this.props.jobPrototype.zipCode
                            : ''
                    )
                        .then((jobCategories: JobCategories[]) => {
                            if (jobCategories.length > 0) {
                                let index = Number(
                                    this.props.jobDetails.selectedJobCategory
                                )
                                let numberOfBags: Array<any> = []
                                jobCategories[index].subcategories &&
                                    jobCategories[index].subcategories.map(
                                        subCategory => {
                                            numberOfBags.push({
                                                subCategoryId: subCategory.name,
                                                count: 0
                                            })
                                        }
                                    )

                                this.props.onSetMsaId(jobCategories[0].msaId)
                                this.props.onSetJobCategories(jobCategories)
                                this.props.onSetSubCategories(
                                    jobCategories[index].subcategories
                                )
                                this.props.onNumberOfBags(numberOfBags)

                                this.setState({
                                    isLoading: false,
                                    jobCategories: jobCategories,
                                    jobCategoryName: this.props.jobDetails
                                        .jobCategoryName,
                                    subCategories:
                                        jobCategories[index].subcategories
                                })
                            } else {
                                this.setState({
                                    isLoading: false,
                                    isErrorDialogOpen: true,
                                    errorTitle: StringResources.getString(
                                        Strings.JobDetails.Errors.Titles.Error
                                    ),
                                    errorMessage: StringResources.getString(
                                        Strings.JobDetails.Errors.Messages
                                            .ServiceIsNotAvailiable
                                    )
                                })
                            }
                            if (jobCategories.length === 1) {
                                this.props.onSelectJobCategory(
                                    jobCategories[0].name,
                                    jobCategories[0].id
                                )
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            this.setState({
                                isLoading: false,
                                isErrorDialogOpen: true,
                                errorTitle: StringResources.getString(
                                    Strings.JobDetails.Errors.Titles.Error
                                ),
                                errorMessage: StringResources.getString(
                                    Strings.JobDetails.Errors.Messages
                                        .ServiceIsNotAvailiable
                                )
                            })
                        })
                }
            )

            const message = await Api.getPreference(
                PreferenceType.TwoJobPicturesMessage
            )
            this.setState({
                twoJobPicturesMessage: message.value
            })
        } else {
            this.props.routePush(ROUTES.PICKUP_LOCATION)
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (this.props !== nextProps) {
            this.checkValidation(nextProps)
        }
        this.setSubCategories(nextProps)

        if (this.state.files !== nextProps.jobDetails.attachments) {
            this.setState({
                files: nextProps.jobDetails.attachments
            })
        }
    }
    setSubCategories = props => {
        if (
            this.props.jobDetails.selectedJobCategory !==
                props.jobDetails.selectedJobCategory &&
            props.jobDetails.jobCategories.length !== 0
        ) {
            let subCategories =
                props.jobDetails.jobCategories[
                    props.jobDetails.selectedJobCategory
                ].subcategories
            this.setState({
                subCategories: subCategories
            })
            this.props.onSetSubCategories(subCategories)
        }
    }

    commentChange = event => {
        this.setState({
            note: event.target.value
        })
        this.props.onAddComment(event.target.value)
    }

    handleImageRemoval = (id: string) => {
        this.setState({
            isDialogOpen: true,
            imageId: id
        })
    }

    deleteImage = () => {
        let tempFiles: Array<any> = this.state.files.filter(
            (file: AttachmentParams) => file.id !== this.state.imageId
        )
        this.props.onSetAttachments(tempFiles)
        this.setState(
            {
                files: tempFiles,
                isImagesMaxNumber: false,
                imageId: '',
                isDialogOpen: false,
                isImagesUploaded: tempFiles.length > 1
            },
            () => {
                this.checkValidation(this.props)
            }
        )
    }

    setJobCategoryName = (name: string) => {
        this.setState({
            jobCategoryName: name
        })
        if (this.state.jobCategoryName !== name) {
            this.setState({
                note: ''
            })
            this.props.onResetCheckboxes()
            this.props.onAddComment('')
            this.props.saveTextareaHeight(50)
        }
    }

    scaleImage = async (
        image,
        width: number,
        height: number,
        quality: number
    ) => {
        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        const context = canvas.getContext('2d')
        if (context) {
            context.drawImage(image, 0, 0, width, height)
            return ImageUtils.getBlob(canvas, 'image/jpeg', quality)
        }
        return null
    }

    reduceImageSize = async (blob, file: Blob) => {
        return new Promise<string>((resolve, reject) => {
            // tslint:disable-next-line: no-floating-promises
            ReaderUtils.read(file, ReaderUtils.ReadType.BLOB).then(data => {
                let tags = exif.readFromBinaryFile(data)
                let orientation: any
                if (
                    tags &&
                    tags.Orientation !== null &&
                    tags.Orientation !== undefined
                ) {
                    orientation = tags.Orientation
                }

                let image = new Image()
                image.src = blob
                image.onload = () => {
                    let width = image.width
                    let height = image.height
                    let aspect = width / height

                    let newWidth: number, newHeight: number
                    if (
                        width <= IMAGE_CONSTANTS.IMG_STORE_WIDTH &&
                        height <= IMAGE_CONSTANTS.IMG_STORE_HEIGHT
                    ) {
                        newWidth = width
                        newHeight = height
                    } else if (
                        width <= IMAGE_CONSTANTS.IMG_STORE_WIDTH &&
                        height > IMAGE_CONSTANTS.IMG_STORE_HEIGHT
                    ) {
                        newHeight = IMAGE_CONSTANTS.IMG_STORE_HEIGHT
                        newWidth = newHeight * aspect
                    } else {
                        newWidth = IMAGE_CONSTANTS.IMG_STORE_WIDTH
                        newHeight = newWidth / aspect
                    }

                    let canvas = document.createElement('canvas')
                    canvas.width = newWidth
                    canvas.height = newHeight

                    let ctx = canvas.getContext('2d')
                    if (ctx) {
                        if (orientation) {
                            if (orientation > 4 && orientation < 9) {
                                canvas.width = newHeight
                                canvas.height = newWidth
                            } else {
                                canvas.width = newWidth
                                canvas.height = newHeight
                            }

                            let scale = newWidth / image.width

                            switch (orientation) {
                                case 2: {
                                    ctx.transform(
                                        -1 * scale,
                                        0,
                                        0,
                                        1 * scale,
                                        newWidth,
                                        0
                                    )
                                    break
                                }
                                case 3: {
                                    ctx.transform(
                                        -1 * scale,
                                        0,
                                        0,
                                        -1 * scale,
                                        newWidth,
                                        newHeight
                                    )
                                    break
                                }
                                case 4: {
                                    ctx.transform(
                                        1 * scale,
                                        0,
                                        0,
                                        -1 * scale,
                                        0,
                                        newHeight
                                    )
                                    break
                                }
                                case 5: {
                                    ctx.transform(
                                        0,
                                        1 * scale,
                                        1 * scale,
                                        0,
                                        0,
                                        0
                                    )
                                    break
                                }
                                case 6: {
                                    ctx.transform(
                                        0,
                                        1 * scale,
                                        -1 * scale,
                                        0,
                                        newHeight,
                                        0
                                    )
                                    break
                                }
                                case 7: {
                                    ctx.transform(
                                        0,
                                        -1 * scale,
                                        -1 * scale,
                                        0,
                                        newHeight,
                                        newWidth
                                    )
                                    break
                                }
                                case 8: {
                                    ctx.transform(
                                        0,
                                        -1 * scale,
                                        1 * scale,
                                        0,
                                        0,
                                        newWidth
                                    )
                                    break
                                }
                                default:
                                    break
                            }
                            ctx.drawImage(image, 0, 0)
                        } else {
                            ctx.drawImage(
                                image,
                                0,
                                0,
                                canvas.width,
                                canvas.height
                            )
                        }

                        canvas.toBlob(
                            blob => {
                                let reader: any = new FileReader()
                                reader.onloadend = () => {
                                    resolve(reader.result)
                                }

                                reader.readAsDataURL(blob as Blob)
                            },
                            'image/jpeg',
                            0.7
                        )
                    } else {
                        reject()
                    }
                }
                image.onerror = reject
                image.src = blob
            })
        })
    }

    reduceToSize = async (blob: Blob, targetSize: number) => {
        let currentSize = blob.size
        if (currentSize <= targetSize) {
            return blob
        }
        console.log(`Blob has size: ${currentSize}`)
        // First, change image quality
        const image = await ReaderUtils.loadImage(
            window.URL.createObjectURL(blob)
        )
        const origWidth = image.width
        const origHeight = image.height
        const aspect = origWidth / origHeight
        let blobResult = await this.scaleImage(
            image,
            origWidth,
            origHeight,
            IMAGE_CONSTANTS.PUBLISH_IMAGE_QUALITY
        )
        if (!blobResult) {
            return null
        }
        currentSize = blobResult.size
        console.log(`Blob size with low quality: ${currentSize}`)
        if (currentSize <= targetSize) {
            return blobResult
        }
        // Secondly, lets play with image with by binary search
        let prevWidth = origWidth
        let lastWidth = origWidth
        do {
            let newWidth: number
            if (currentSize > targetSize) {
                newWidth = lastWidth / 2
            } else {
                newWidth = lastWidth + (prevWidth - lastWidth) / 2
            }
            const newHeight = newWidth / aspect
            prevWidth = lastWidth
            lastWidth = newWidth
            blobResult = await this.scaleImage(
                image,
                newWidth,
                newHeight,
                IMAGE_CONSTANTS.PUBLISH_IMAGE_QUALITY
            )
            if (!blobResult) {
                return null
            }
            currentSize = blobResult.size
            console.log(`Blob size on current iteraion: ${currentSize}`)
        } while (currentSize > targetSize)
        return blobResult
    }

    blobToDataUrl = async (blob: Blob) => {
        return ReaderUtils.read(blob, ReaderUtils.ReadType.DATA_URL)
    }

    onChangeImg = async (
        base64Img: string,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        let tempFiles =
            this.state.files && this.state.files !== null
                ? this.state.files
                : []

        if (tempFiles.length === 0) {
            this.setState({
                messageDialog: {
                    isDialogOpened: true,
                    message: this.state.twoJobPicturesMessage,
                    title: 'Set Job Details',
                    actions: [
                        {
                            caption: 'Ok',
                            onClick: () => {
                                this.setState({
                                    messageDialog: { isDialogOpened: false }
                                })
                            }
                        }
                    ]
                }
            })
        }

        this.setState({
            isLoadingImg: true,
            currentOperation: StringResources.getString(
                Strings.JobDetails.TitleOperations.uploadingImage
            )
        })
        if (!e.target || !e.target.files) {
            return
        }
        let file = e.target.files[0]
        let reducedImageIconb64 = await this.reduceImageSize(base64Img, file)
        let uploadedBlob = await fetch(base64Img).then(r => r.blob())
        //console.log('uploadedBlob', uploadedBlob)
        let reducedBlob = await this.reduceToSize(
            uploadedBlob,
            IMAGE_CONSTANTS.MAX_BLOB_SIZE
        )
        console.log('reducedBlob', reducedBlob)
        let reducedBase64 = (await ReaderUtils.read(
            reducedBlob,
            ReaderUtils.ReadType.BASE64
        )) as string
        //console.log('reducedBase64', reducedBase64)
        //console.log('norm ', base64Img)
        //console.log('magic', base64Img.substring(base64Img.indexOf(',') + 1))
        if (tempFiles.length < IMAGES_MAX_NUMBER) {
            Api.createAttachment({
                type: Enums.AttachmentType.JOB_PICTURE,
                ownerId: '',
                overwrite: false,
                base64Image: reducedBase64.substring(base64Img.indexOf(',') + 1) // backend requirements. del base64 attributes, for instance: data:image/jpeg;base64,
                //base64Image: reducedBase64
            })
                .then(result => {
                    if (result.recognitionResult) {
                        this.setState({
                            isInappropriatePhoto: true,
                            errorMessage: Strings.Common.InappropriatePhoto,
                            errorTitle: Strings.Common.Error,
                            currentOperation: '',
                            isLoadingImg: false
                        })
                        return
                    }
                    let attachment: AttachmentParams = Object.assign(
                        {},
                        {
                            base64: reducedImageIconb64
                                ? reducedImageIconb64
                                : base64Img
                        },
                        result
                    )
                    tempFiles.push(attachment)
                    if (tempFiles.length === IMAGES_MAX_NUMBER) {
                        this.setState({
                            isImagesMaxNumber: true
                        })
                    } else {
                        this.setState({
                            isImagesMaxNumber: false
                        })
                    }

                    this.setState({
                        currentOperation: '',
                        isLoadingImg: false,
                        isImagesUploaded: tempFiles.length > 1
                    })
                })
                .then(() =>
                    this.setState(prevState => {
                        let state = {
                            ...prevState,
                            [e.target.name]: base64Img,
                            showImageEditor: true,
                            fieldsError: false
                        }
                        return state
                    })
                )
                .then(() => {
                    this.props.onSetAttachments(tempFiles)
                })
                .catch(error => {
                    this.props.onErrorEvent(Mapper.mapError(error))
                    console.log('Error while uploading image', error)
                })
        }
    }

    checkValidation = (props: any) => {
        let countable =
            props.jobDetails.jobCategories.length !== 0 &&
            props.jobDetails.selectedJobCategory &&
            props.jobDetails.jobCategories[props.jobDetails.selectedJobCategory]
                .countable

        let hour: number = moment(props.jobDetails.futureDateTo).hour()

        let bagsCount =
            props.jobDetails.jobItems &&
            props.jobDetails.jobItems.find(jobItem => jobItem.count !== 0)

        let status = props.jobDetails.status
        let isThereActiveJob: boolean

        if (status && status !== '') {
            isThereActiveJob = true
        } else {
            isThereActiveJob = false
        }

        if (
            props.address !== null &&
            !isThereActiveJob &&
            this.state.isImagesUploaded &&
            // props.jobDetails.futureDateTo !== 0 &&
            // props.jobDetails.futureDateTo !== null &&
            // hour !== 0 &&
            (props.jobDetails.areItemsOutside === true ||
                props.jobDetails.areItemsInside === true) &&
            ((countable && bagsCount && bagsCount.count !== 0) ||
                (!countable &&
                    !!props.jobDetails.attachments &&
                    props.jobDetails.attachments.length !== 0))
        ) {
            this.setState({
                isValid: true
            })
        } else {
            this.setState({
                isValid: false
            })
        }
    }

    handleClick = async () => {
        const { jobPrototype } = this.props
        if (jobPrototype.jobRequestId) {
            const newObj: any = {
                ...this.props.jobPrototype,
                status: JobRequestStatus.AT_JOB_AVAILABILITY
            }
            await Api.updateJobRequest(jobPrototype.jobRequestId, newObj)
        }

        this.props.routePush(ROUTES.SET_AVAILABITILY)
    }

    handleDialogClose = () => {
        this.setState({
            isDialogOpen: false
        })
    }

    handleErrorDialogClose = () => {
        this.props.setUseCurrentJob()
        this.props.routePush(ROUTES.PICKUP_LOCATION)
    }

    handleInappropriatePhotoDialogClose = () => {
        this.setState({
            isInappropriatePhoto: false
        })
    }

    handleRouteChange = (location: string) => {
        this.props.setUseCurrentJob()
        return this.props.routePush(location)
    }

    handleImageClick = (iconIndex: number) => {
        this.setState({ photoIndex: iconIndex, isImagesBoxOpen: true })
    }

    saveTextareaHeight = (minHeight: number) => {
        this.props.saveTextareaHeight(minHeight)
    }

    scrollDown = () => {
        const element = ReactDOM.findDOMNode(this.scroll.current)
        if (element instanceof Element) {
            element.scrollTop = element.scrollHeight
        }
    }

    render() {
        let { photoIndex, files } = this.state
        let imgSrcs =
            files &&
            files.map(file => {
                return { src: file.base64 }
            })
        return (
            <BaseContainer pageName={EventType.JOB_DETAILS}>
                <LoadingSpinner show={this.state.isLoading} />
                <Lightbox
                    images={imgSrcs ? imgSrcs : []}
                    currentImage={photoIndex}
                    showImageCount={true}
                    isOpen={this.state.isImagesBoxOpen}
                    // tslint:disable-next-line:jsx-no-lambda
                    onClickPrev={() => {
                        this.setState({
                            photoIndex:
                                (photoIndex + files.length - 1) % files.length
                        })
                    }}
                    // tslint:disable-next-line:jsx-no-lambda
                    onClickNext={() => {
                        this.setState({
                            photoIndex: (photoIndex + 1) % files.length
                        })
                    }}
                    // tslint:disable-next-line:jsx-no-lambda
                    onClose={() => {
                        this.setState({ isImagesBoxOpen: false })
                    }}
                    rotatable={true}
                    zoomable={true}
                />
                <AppBarContainer
                    isIconButtonsShown={true}
                    isMenuShown={false}
                    resetStore={true}
                />
                <PageTitle
                    text={StringResources.getString(Strings.JobDetails.Title)}
                    currentOperation={this.state.currentOperation}
                />
                <PerfectScrollbar
                    className="vertical-scrollbar"
                    ref={this.scroll}
                >
                    <AcceptDialog
                        action={Actions.DELETE}
                        isAcceptDialogOpen={this.state.isDialogOpen}
                        handleDialogClose={this.handleDialogClose}
                        deleteImage={this.deleteImage}
                    />
                    <PickupLocationInfo
                        routePush={this.handleRouteChange}
                        address={this.props.jobDetails.address}
                    />
                    {this.state.jobCategories.length === 1 ? null : (
                        <JobCategory
                            onSelectJobCategory={this.props.onSelectJobCategory}
                            setJobCategoryName={this.setJobCategoryName}
                            jobCategories={this.state.jobCategories}
                            selectedJobCategory={
                                this.props.jobDetails.selectedJobCategory
                            }
                            onSetSelectedJobCategory={
                                this.props.onSetSelectedJobCategory
                            }
                            disabled={this.state.isLoadingImg}
                        />
                    )}
                    <div className="job-items-div">
                        {this.state.jobCategories.length !== 0 ? (
                            this.state.jobCategories[
                                this.props.jobDetails.selectedJobCategory
                            ].countable ? (
                                <NumberOfItems
                                    onNumberOfBags={this.props.onNumberOfBags}
                                    setAmount={this.props.onSetAmount}
                                    subCategories={this.state.subCategories}
                                    jobItems={this.props.jobDetails.jobItems}
                                    amount={this.props.jobDetails.amount}
                                    removeAllImages={
                                        this.props.onRemoveAllImages
                                    }
                                />
                            ) : (
                                <Uploader
                                    onChangeImg={this.onChangeImg}
                                    img={this.state.userAvatarBg}
                                    name="userAvatarBg"
                                    handleImageRemoval={this.handleImageRemoval}
                                    files={this.props.jobDetails.attachments}
                                    isImagesMaxNumber={
                                        this.state.isImagesMaxNumber
                                    }
                                    isLoading={this.state.isLoadingImg}
                                    jobCategoryName={this.state.jobCategoryName}
                                    removeAllImages={
                                        this.props.onRemoveAllImages
                                    }
                                    handleImageClick={this.handleImageClick}
                                    onNumberOfBags={this.props.onNumberOfBags}
                                />
                            )
                        ) : null}
                    </div>
                    {/* <PickupTime
            onSetFutureDateFrom={this.props.onSetFutureDateFrom}
            onSetFutureDateTo={this.props.onSetFutureDateTo}
            onSetTime={this.props.onSetTime}
            jobDetails={this.props.jobDetails}
            onSetTimeMarks={this.props.onSetTimeMarks}
            scrollDown={this.scrollDown}
          /> */}
                    <JobItemDetails
                        onSetItemsOutside={this.props.onSetItemsOutside}
                        onSetItemsInside={this.props.onSetItemsInside}
                        onSetElevatorNeeded={this.props.onSetElevatorUse}
                        onSetStairsNeeded={this.props.onSetStairsNeeded}
                        isElevatorNeeded={
                            this.props.jobDetails.isElevatorNeeded
                        }
                        areStairsNeeded={this.props.jobDetails.areStairsNeeded}
                        areItemsOutside={this.props.jobDetails.areItemsOutside}
                        areItemsInside={this.props.jobDetails.areItemsInside}
                    />
                    <ErrorDialog
                        isErrorDialogOpen={this.state.isErrorDialogOpen}
                        errorTitle={this.state.errorTitle}
                        errorMessage={this.state.errorMessage}
                        handleErrorDialogClose={this.handleErrorDialogClose}
                    />
                    <ErrorDialog
                        isErrorDialogOpen={this.state.isInappropriatePhoto}
                        errorTitle={this.state.errorTitle}
                        errorMessage={this.state.errorMessage}
                        handleErrorDialogClose={
                            this.handleInappropriatePhotoDialogClose
                        }
                    />
                    <div className="Pickup-info">
                        <div className="title">
                            {StringResources.getString(
                                Strings.JobDetails.SubTitles.Comments
                            )}
                        </div>
                        <Comment
                            commentChange={this.commentChange}
                            note={this.state.note}
                            maxCommentLength={5000}
                            isCounterRequired={true}
                            saveTextareaHeight={this.saveTextareaHeight}
                            minHeight={this.props.jobDetails.minHeight}
                        />
                    </div>
                </PerfectScrollbar>
                <StickyContainer className="sticky-footer">
                    <Sticky>
                        {() => (
                            <div className={'bottom-part hover'}>
                                {this.state.isValid ? (
                                    <FlatButton
                                        label={StringResources.getString(
                                            Strings.JobDetails.Buttons.Next
                                                .label
                                        )}
                                        className="flatbutton next"
                                        onClick={this.handleClick}
                                    />
                                ) : (
                                    <FlatButton
                                        label={StringResources.getString(
                                            Strings.JobDetails.Buttons.Next
                                                .label
                                        )}
                                        className="flatbutton next disabled"
                                        disabled={true}
                                    />
                                )}
                            </div>
                        )}
                    </Sticky>
                </StickyContainer>
                <MessageDialog {...this.state.messageDialog} />
            </BaseContainer>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        jobPrototype: state.currentJob,
        jobDetails: state.jobDetails,
        zipCode: state.jobDetails.zipCode
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        onSelectJobCategory: (name: string, id: string) =>
            dispatch(selectJobCategory(name, id)),
        onAddComment: (note: string) => dispatch(addComment(note)),
        onSetFutureDateFrom: (futureDateFrom: number) =>
            dispatch(setFutureDateFrom(futureDateFrom)),
        onSetFutureDateTo: (futureDateTo: number) =>
            dispatch(setFutureDateTo(futureDateTo)),
        onNumberOfBags: (jobItem: [{ subCategoryId: string; count: number }]) =>
            dispatch(setBagsNumber(jobItem)),
        onSetItemsOutside: (areItemsOutside: boolean) =>
            dispatch(setItemsOutside(areItemsOutside)),
        onSetItemsInside: (areItemsInside: boolean) =>
            dispatch(setItemsInside(areItemsInside)),
        onSetAmount: (amount: number) => dispatch(setAmount(amount)),
        onSetMsaId: (msaId: string) => dispatch(setMsaId(msaId)),
        onSetElevatorUse: (isElevatorNeeded: boolean) =>
            dispatch(setElevatorUse(isElevatorNeeded)),
        onSetStairsNeeded: (areStairsNeeded: boolean) =>
            dispatch(setStairsNeeded(areStairsNeeded)),
        onSetAttachments: (files: Array<any>) =>
            dispatch(setAttachments(files)),
        onSetJobCategories: (jobCategories: Array<any>) =>
            dispatch(setJobCategories(jobCategories)),
        onSetSelectedJobCategory: (selectJobCategory: string) =>
            dispatch(setSelectedJobCategory(selectJobCategory)),
        onSetSubCategories: (subCategories: Array<any>) =>
            dispatch(setSubCategories(subCategories)),
        onSetTime: (time: {
            time: number
            futureTime: number
            isFuture: number
            minTime: number
        }) => dispatch(setTime(time)),
        routePush: (location: string) => dispatch(routerActions.push(location)),
        onSetTimeMarks: (marks: any) => dispatch(setTimeMarks(marks)),
        setAddress: (address?: AddressInfo) => dispatch(setAddress(address)),
        setCoords: (coords?: string) => dispatch(setCoords(coords)),
        setApartmentNumber: (apartmentNumber?: string) =>
            dispatch(
                setApartmentNumber(apartmentNumber ? apartmentNumber : '')
            ),
        setZipCode: (zipCode?: string) =>
            dispatch(setZipCode(zipCode ? zipCode : '')),
        setUseCurrentJob: () =>
            dispatch(ServiceInfoActions.useCurrentJob(true)),
        onRemoveAllImages: () => dispatch(removeAllImages()),
        onResetCheckboxes: () => dispatch(resetCheckboxes()),
        saveTextareaHeight: (minHeight: number) =>
            dispatch(saveTextareaHeight(minHeight)),
        onErrorEvent: (errorInfo: ErrorInfo) =>
            dispatch(ErrorActions.newError(errorInfo)),
        setJobRequestId: (jobRequestId?: string) =>
            dispatch(setJobRequestId(jobRequestId ? jobRequestId : ''))
    }
}

const SetJobDetails = connect<any>(
    mapStateToProps,
    mapDispatchToProps
)(SetJobDetailsComponent)

export default SetJobDetails



// WEBPACK FOOTER //
// ./src/containers/SetJobDetails.tsx